import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue'

import { PRIMARY_LOCALE, type CompletionResult, type SectionConfig } from '@/components/ProfileCompletion/completionTypes'

export function computeProfileCompletion<T>(
  entity: T,
  sections: SectionConfig<T>[],
  primaryLocale: string = PRIMARY_LOCALE,
): CompletionResult {
  let totalWeight = 0
  let totalDone = 0

  const sectionResults = sections.map((section) => {
    let weightSum = 0
    let doneSum = 0
    for (const field of section.fields) {
      const weight = field.weight ?? 1
      weightSum += weight
      if (field.isComplete(entity, primaryLocale)) {
        doneSum += weight
      }
    }
    totalWeight += weightSum
    totalDone += doneSum
    return {
      id: section.id,
      labelKey: section.labelKey,
      editRouteName: section.editRouteName,
      percentage: weightSum === 0 ? 0 : Math.round((doneSum / weightSum) * 100),
    }
  })

  return {
    sections: sectionResults,
    total: totalWeight === 0 ? 0 : Math.round((totalDone / totalWeight) * 100),
  }
}

export function useProfileCompletion<T>(
  entity: MaybeRefOrGetter<T>,
  sections: SectionConfig<T>[],
  primaryLocale: string = PRIMARY_LOCALE,
): ComputedRef<CompletionResult> {
  return computed(() => computeProfileCompletion(toValue(entity), sections, primaryLocale))
}
